import { createFileRoute } from "@tanstack/react-router";
import { ExplorePage } from "@/app-clients/browse-dogs/routes/explore-page";
import { browseDogsExploreRoute } from "@/app-clients/browse-dogs/routes/explore-route";

export const Route = createFileRoute("/explore")({
    validateSearch: browseDogsExploreRoute.validateSearch,
    ssr: browseDogsExploreRoute.ssr,
    beforeLoad: browseDogsExploreRoute.beforeLoad,
    head: browseDogsExploreRoute.head,
    component: ExplorePage,
});
